function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
  id: "path-1-right",
  cx: 10,
  cy: 10,
  r: 10
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "pop-up/action/download-logs/date-range-copy-2",
  transform: "translate(-232.000000, -187.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon/sf-contain-b-copy-4",
  transform: "translate(242.000000, 197.000000) scale(-1, 1) rotate(-270.000000) translate(-242.000000, -197.000000) translate(232.000000, 187.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1-right"
})), /*#__PURE__*/React.createElement("use", {
  id: "Mask",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  xlinkHref: "#path-1-right"
}), /*#__PURE__*/React.createElement("g", {
  id: "icon/sf-small/wizzard",
  mask: "url(#mask-2)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(6.666667, 6.000000)",
  id: "Group"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
  id: "Path-3",
  stroke: "#1B2559",
  strokeWidth: 2,
  points: "0 4.83333333 3.33333333 8.16666667 6.66666667 4.83333333"
}), /*#__PURE__*/React.createElement("line", {
  x1: 3.33333333,
  y1: 0.25,
  x2: 3.33333333,
  y2: 6.5,
  id: "Path-4",
  stroke: "#1B2559",
  strokeWidth: 2
})))))));

function SvgRightWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightWhite);
export default __webpack_public_path__ + "static/media/right_white.3e1a2119.svg";
export { ForwardRef as ReactComponent };